<template>
  <div style="width: 100%;order: 2;">
    <div class="row" style="margin-bottom: 50px;">
      <div class="col-md-8">
        <table class="tdesk-table--compact justified" style="font-size: 14px;">
          <thead>
            <tr>
              <th>Name</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="participant in order.participants"
              :key="participant.id"
              class="participant"
            >
              <td>{{ `${participant.first_name} ${participant.last_name ? participant.last_name : ''}` }}</td>
              <td style="width:80px;">
                <span v-if="perPersonFee">{{ `$${perPersonFee}` }}</span>
                <span v-else>-</span>
              </td>
            </tr>
            <template v-if="appliedVouchers">
              <tr
                v-for="voucher in appliedVouchers"
                :key="voucher.id"
              >
                <td>
                  <h4 style="margin:0;">
                    {{ voucher.code }}
                  </h4>
                </td>
                <td class="tdesk-body--emphasis tdesk-secondary-active">
                  - ${{ parseFloat(voucher.adjustment).toFixed(2) }}
                </td>
              </tr>
            </template>
            <tr v-if="gstAmount && !domain.skipPayment">
              <td>
                <h4 style="margin:0;" class="tdesk-neutral">
                  GST
                </h4>
              </td>
              <td class="tdesk-body--emphasis tdesk-neutral">
                +${{ parseFloat(gstAmount).toFixed(2) }}
              </td>
            </tr>
            <tr>
              <td>
                <h4 v-if="gstAmount > 0" style="margin:0; color: black;">
                  TOTAL (inc. GST)
                </h4>
                <h4 v-else style="margin:0; color: black;">
                  Total
                </h4>
              </td>
              <td class="tdesk-body--emphasis" style="color: black;">
                <span v-if="!domain.skip_payment">${{ parseFloat(total).toFixed(2) }}</span>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-4">
        <vouchers
          :client-id="clientId"
          :applied-vouchers="order.appliedVouchers"
          :total="parseFloat(total)"
          :number-of-participants="order.participants.length"
          :course-id="order.course.id"
          @apply-vouchers="applyVouchers($event)"
          @remove-voucher="removeVoucher($event)"
        />
        <div v-if="clientPricingApplied">
          <div class="tdesk-secondary-box-container">
            <div>
              <div class="tdesk-body--small">
                Client pricing applied
              </div>
              <div class="tdesk-body--small tdesk-secondary-active">
                {{ order.client.name }}
              </div>
            </div>
            <div />
          </div>
        </div>
      </div>
    </div>
    <div class="row tdesk-offwhite bg" style="padding: 20px 0;">
      <div v-if="total > 0" class="col-md-12">
        <h2 class="v2-heading-2" style="margin-bottom: 20px;">
          Payment details
        </h2>
        <form class="tdesk-form" @submit.prevent="handleSubmit()">
          <div v-if="availablePaymentOptions.pay_on_day" class="form-group radio">
            <input
              id="pay_on_day"
              v-model="paymentMethod"
              type="radio"
              value="pay_on_day"
            >
            <label for="pay_on_day">Payment on the day</label>
          </div>

          <div
            v-if="availablePaymentOptions.credit_card_payment"
            class="form-group radio"
          >
            <input
              id="pay_by_cc"
              v-model="paymentMethod"
              type="radio"
              :value="PAYMENT_METHOD.CREDIT_CARD"
            >
            <label for="pay_by_cc">Credit / Debit Card</label>

            <div v-if="paymentMethod == PAYMENT_METHOD.CREDIT_CARD" style="margin-left: 30px">
              <h4>Who is making this payment?</h4>

              <div class="form-group radio">
                <input
                  id="invoice-me"
                  v-model="invoice.kind"
                  type="radio"
                  :value="INVOICE_TO.MYSELF"
                  name="invoice-option"
                >
                <label for="invoice-me">Myself</label>
              </div>

              <div v-if="clientAssociated" class="form-group radio">
                <input
                  id="invoice-client"
                  v-model="invoice.kind"
                  type="radio"
                  :value="INVOICE_TO.CLIENT"
                  name="invoice-option"
                >
                <label for="invoice-client">{{ order.client.name }}</label>
              </div>

              <div class="form-group radio">
                <input
                  id="invoice-other"
                  v-model="invoice.kind"
                  type="radio"
                  :value="INVOICE_TO.OTHER"
                  name="invoice-option"
                >
                <label for="invoice-other">Other (e.g. company)</label>
              </div>

              <div class="row">
                <div v-if="invoice.kind == INVOICE_TO.OTHER" class="col-md-6 form-group">
                  <input v-model="invoice.company" type="text" placeholder="e.g company">
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="availablePaymentOptions.invoice"
            class="form-group radio"
          >
            <input
              id="invoice"
              v-model="paymentMethod"
              type="radio"
              value="invoice"
            >
            <label for="invoice">Invoice to {{ order.client.name }}</label>
          </div>
          <button
            type="submit"
            class="tdesk-primary-button pull-right"
            :disabled="!paymentMethod"
          >
            <i class="fas fa-shopping-cart" />
            Complete your order
          </button>
        </form>
      </div>
      <div v-else class="col-md-12">
        <button
          type="button"
          class="tdesk-primary-button pull-right finalise-order-button"
          @click="handleSubmit()"
        >
          <i class="fas fa-shopping-cart" />
          Finalise your order
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import Vouchers from './vouchers';
  import fireGaEvent from './fire_ga_event';
  import { INVOICE_TO, PAYMENT_METHOD } from './constants';

  export default {
    components: {Vouchers},
    props: {
      order: {
        required: true,
        type: Object,
      },
      domain: {
        required: true,
        type: Object,
      },
      feesCalculationPath: {
        required: true,
        type: String,
      },
      availablePaymentMethodsPath: {
        required: true,
        type: String,
      },
    },
    data() {
      return {
        INVOICE_TO,
        PAYMENT_METHOD,
        paymentMethod: null,
        appliedVouchers: this.order.appliedVouchers,
        total: null,
        fee: null,
        priceWithoutGst: null,
        clientPricingApplied: false,
        gstAmount: null,
        invoice: { kind: INVOICE_TO.MYSELF },
        availablePaymentOptions: {
          pay_on_day: false,
          credit_card_payment: false,
          invoice: false,
        },
      };
    },
    computed: {
      clientId() {
        return this.order.client ? this.order.client.id : null;
      },
      feeType() {
        return this.order.course.fee_type;
      },
      perPersonFee() {
        if (this.domain.skip_payment) {return;}
        if (this.feeType === 'per_person') {
          return parseFloat(this.fee).toFixed(2);
        }
        return undefined;
      },
      invoiceOptions: function() {
        if (this.paymentMethod === PAYMENT_METHOD.CREDIT_CARD) {
          let options = { kind: this.invoice.kind };

          if (this.invoice.kind === INVOICE_TO.OTHER) {
            options.company = this.invoice.company;
          }

          return options;
        } else {
          return null;
        }
      },
      clientAssociated: function() {
        return this.order.client && this.order.client.id > 0;
      },
    },
    watch: {
      total: function(val) {
        this.$emit('update-total', val);
      },
      appliedVouchers: function(val) {
        this.$emit('update-vouchers', val);
      },
    },
    mounted() {
      this.total = this.calculateTotal();
      this.$emit('change-page-title', 'Payment');
      this.fetchPaymentOptions();
    },
    methods: {
      fetchPaymentOptions() {
        let data = {
          cid: this.order.course.id,
          client_id: this.clientId,
        };
        axios
            .get(Routes[this.availablePaymentMethodsPath](data))
            .then(rsp => {
              this.availablePaymentOptions = rsp.data;
            });
      },
      handleSubmit() {
        this.$emit('add-payment-method', this.paymentMethod);
        this.$emit('add-invoice-options', this.invoiceOptions);

        if (this.total > 0) {
          fireGaEvent('ssbc_v2_step5_select_payment_type', {'payment_type': this.paymentMethod});

          return this.$emit('proceed');
        }

        this.$emit('add-payment-method', 'free');
        fireGaEvent('ssbc_v2_step5_select_payment_type', {'payment_type': 'free'});
        this.$emit('finalize');
      },
      applyVouchers(vouchers) {
        this.appliedVouchers = vouchers;
        this.calculateTotal();
      },
      removeVoucher(voucherId) {
        axios
            .put(Routes.unapply_voucher_path({vid: voucherId}))
            .then(() => this.calculateTotal());
        this.appliedVouchers = this.appliedVouchers.filter(v => v.id !== voucherId);
      },
      calculateTotal() {
        let data = {
          cid: this.order.course.id,
          nmbpar: this.order.participants.length,
          clid: this.clientId,
          vids: this.appliedVouchers.map(voucher => voucher.id),
        };

        axios
            .get(Routes[this.feesCalculationPath](data))
            .then(rsp => {
              this.total = rsp.data.total;
              this.fee = rsp.data.fee;
              this.priceWithoutGst = rsp.data.price_without_gst;
              this.clientPricingApplied = rsp.data.custom_price_applied;
              this.$emit('apply-client-pricing', this.clientPricingApplied);
              this.gstAmount = rsp.data.gst_amount;
            });
      },
    },
  };
</script>
